import { createSlice } from '@reduxjs/toolkit';

import { initialState } from '../redux';

const resetOnboardingState = (
  createAccountDisclaimer,
  legalStatus,
  legalStatusList,
) => ({
  ...initialState.auth.onboarding,
  ...(createAccountDisclaimer !== undefined && {
    createAccountDisclaimer,
  }),
  ...(legalStatus !== undefined && {
    legalStatus,
  }),
  ...(legalStatusList !== undefined && {
    legalStatusList,
  }),
});

export const logoutSlice = createSlice({
  name: 'logoutSlice',
  initialState,
  reducers: {
    logoutRequest: (state) => {
      state.isLoading = true;
    },
    logoutSuccess: (state, action) => {
      const { showAlert, hasInvalidToken } = action.payload;

      return {
        ...initialState.auth,
        showLogoutAlert: showAlert,
        hasInvalidToken,
        onboarding: resetOnboardingState(
          state.onboarding.createAccountDisclaimer,
          state.onboarding.legalStatus,
          state.onboarding.legalStatusList,
        ),
      };
    },
    /**
     * Mesmo no caso de o request à framework falhar
     * o estado é reposto para o estado inicial.
     */
    logoutFailure: (state) => {
      return {
        ...initialState.auth,
        onboarding: resetOnboardingState(
          state.onboarding.createAccountDisclaimer,
          state.onboarding.legalStatus,
          state.onboarding.legalStatusList,
        ),
      };
    },
    hideLogoutAlert: (state) => ({ ...state, showLogoutAlert: false }),
  },
});
